import oAxiosInstance from "config/Axios";

export const apiCallGetCurrencyChange = (nCurrencyId) => {
  return oAxiosInstance.get(`cotizaciones/actual/${nCurrencyId}`);
};

export const apiCallGetUserManual = () => {
  return oAxiosInstance.get("herramientas/manualdeusuario");
};
